{
  "COMPOSE_REDIRECT": {
    "OPENING": "Otevírám novou konverzaci s {email}…",
    "NO_EMAIL": "Nebyla zadána e-mailová adresa. Použijte ?email=jmeno@example.com",
    "CONTACT_ERROR": "Kontakt pro {email} se nepodařilo najít."
  },
  "CONVERSATION": {
    "IMAGE_RESIZE": {
      "SMALL": "Malý",
      "MEDIUM": "Střední",
      "LARGE": "Velký",
      "ORIGINAL": "Originál"
    },
    "SHOW_HIDDEN_MESSAGES": "Zobrazit skryté zprávy",
    "SELECT_A_CONVERSATION": "Vyberte prosím konverzaci z levého panelu",
    "CSAT_REPLY_MESSAGE": "Ohodnoťte prosím konverzaci",
    "404": "Omlouváme se, konverzaci nelze najít. Zkuste to prosím znovu",
    "SWITCH_VIEW_LAYOUT": "Přepnout rozložení",
    "DASHBOARD_APP_TAB_MESSAGES": "Zprávy",
    "UNVERIFIED_SESSION": "Identita tohoto uživatele není ověřena",
    "NO_MESSAGE_1": "Ale ne! Vypadá to, že ve vaší schránce nejsou žádné zprávy od zákazníků.",
    "NO_MESSAGE_2": " pro odeslání zprávy na vaši stránku!",
    "NO_INBOX_1": "Hola! Zdá se, že jste ještě nepřidali žádné schránky.",
    "NO_INBOX_2": " začít",
    "NO_INBOX_AGENT": "Uh Oh! Vypadá to, že nejste součástí žádné schránky. Obraťte se na správce",
    "SEARCH_MESSAGES": "Hledat zprávy v konverzacích",
    "VIEW_ORIGINAL": "Zobrazit originál",
    "VIEW_TRANSLATED": "Zobrazit překlad",
    "TRANSLATION": "Překlad",
    "EMPTY_STATE": {
      "CMD_BAR": "pro otevření příkazového menu",
      "KEYBOARD_SHORTCUTS": "pro zobrazení klávesových zkratek"
    },
    "SEARCH": {
      "TITLE": "Hledat zprávy",
      "RESULT_TITLE": "Výsledky hledání",
      "LOADING_MESSAGE": "Načítám data...",
      "PLACEHOLDER": "Zadejte jakýkoli text k hledání",
      "NO_MATCHING_RESULTS": "Žádné výsledky."
    },
    "TRANSCRIPT": {
      "SHOW": "Zobrazit celý přepis",
      "HIDE": "Skrýt celý přepis",
      "DOWNLOAD": "Stáhnout přepis",
      "COPY": "Kopírovat přepis"
    },
    "INVISIBLE_TO_CUSTOMER": "Neviditelné pro zákazníka",
    "SENT_VIA_EMAIL": "Odesláno kontaktu i e-mailem ({time})",
    "UNREAD_MESSAGES": "Nepřečtené zprávy",
    "UNREAD_MESSAGE": "Nepřečtená zpráva",
    "CLICK_HERE": "Klikněte zde",
    "LOADING_INBOXES": "Načítání schránek",
    "LOADING_CONVERSATIONS": "Načítání konverzací",
    "CANNOT_REPLY": "Nemůžete odpovědět z důvodu",
    "24_HOURS_WINDOW": "24 hodinové omezení okna",
    "API_HOURS_WINDOW": "Na tuto konverzaci můžete odpovědět pouze v rámci {hours} hodin",
    "FACEBOOK_CANNOT_REPLY": "Pokud potřebujete pokračovat v této konverzaci, ",
    "NOT_ASSIGNED_TO_YOU": "Tato konverzace vám není přiřazena. Chcete si přiřadit tuto konverzaci?",
    "ASSIGN_TO_ME": "Přiřadit mi",
    "PENDING_WITH_BOT_BANNER": "Tuto konverzaci zpracovává AI agent. Pokud chcete reagovat, nejprve ji otevřete.",
    "INBOX_DELETE_REQUESTED_BANNER": "Tato schránka je označena ke smazání, takže odpověď zákazníka by nikdy nedorazila. Pro odpověď přesuňte konverzaci do jiné schránky.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Tento kontakt má další otevřenou konverzaci #{id}",
      "MULTIPLE": "Tento kontakt má další otevřené konverzace ({count})",
      "OPEN": "Otevřít",
      "SHOW": "Zobrazit"
    },
    "TWILIO_WHATSAPP_CAN_REPLY": "Na tuto konverzaci můžete odpovědět pouze pomocí šablony zprávy z důvodu",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 hodinové omezení okna",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Tento Instagram účet byl migrován do nové Instagram schránky. Všechny nové zprávy se budou zobrazovat tam. V této konverzaci již nebudete moci odesílat zprávy.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Nelze odeslat zprávu, protože zákazník není online a není možné pokračovat v konverzaci emailem.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "Odeslanou zprávu nemusí zákazník dostat, protože není online a není možné pokračování emailem.",
    "REPLYING_TO": "Odpovídáte uživateli:",
    "REMOVE_SELECTION": "Odstranit výběr",
    "DOWNLOAD": "Stáhnout",
    "OPEN_FILE": "Otevřít",
    "DOWNLOAD_ATTACHMENTS": "Stáhnout vše",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Stáhnout všechny přílohy postupně",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Stáhnout vše jako ZIP",
    "ERROR_DOWNLOADING_FILE": "Chyba při stahování souboru",
    "UNKNOWN_FILE_TYPE": "Neznámý soubor",
    "SAVE_CONTACT": "Uložit",
    "NO_CONTENT": "Žádný obsah k zobrazení",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Před odesláním proveďte:",
      "EXECUTE": "Provést",
      "RETRY": "Zkusit znovu",
      "CONFIRM": "Opravdu provést?",
      "CONFIRM_YES": "Ano, provést",
      "CONFIRM_NO": "Zrušit",
      "RUNNING": "Probíhá…",
      "DONE": "Provedeno",
      "CLAIM_DELAYED": "založí se po doručení objednávky",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Založen NOVÝ ticket {reference}, {planned} je uzavřený — upravte text návrhu",
        "NEW_CLAIM": "Založen NOVÝ ticket {reference} místo doplnění {planned} — upravte text návrhu",
        "OTHER_CLAIM": "Doplněn ticket {reference} místo {planned} — upravte text návrhu",
        "EXISTING_CLAIM": "Nový ticket nezaložen, doplněn existující {reference} — upravte text návrhu",
        "OTHER": "Proběhlo jinak, než návrh počítal — upravte text návrhu"
      },
      "FAILED": "Nepodařilo se",
      "UNREACHABLE": "Bot není dostupný",
      "REQUEST_FAILED": "Akci se nepodařilo spustit, zkuste to prosím znovu.",
      "ACTIONS": {
        "CANCEL_ORDER": "Zrušit objednávku",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Změnit platbu na dobírku",
        "CREATE_CLAIM": "Založit reklamaci",
        "CREATE_OR_UPDATE_CLAIM": "Založit nebo upravit reklamaci",
        "EXTEND_ORDER_PICKUP_DATE": "Prodloužit lhůtu k vyzvednutí"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} sdílel kontakt",
      "LOCATION": "{sender} sdílel polohu",
      "FILE": "{sender} sdílel soubor"
    },
    "UPLOADING_ATTACHMENTS": "Nahrávání příloh...",
    "REPLIED_TO_STORY": "Odpověděl na váš příběh",
    "UNSUPPORTED_MESSAGE": "Tato zpráva není podporována.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Tato zpráva není podporována. Můžete ji zobrazit v aplikaci Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Tato zpráva není podporována. Můžete ji zobrazit v aplikaci Instagram.",
    "SUCCESS_DELETE_MESSAGE": "Zpráva byla úspěšně smazána",
    "FAIL_DELETE_MESSSAGE": "Zpráva se nepodařilo odstranit! Zkuste to znovu",
    "NO_RESPONSE": "Bez odpovědi",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Požádat zákazníka o sdílení jeho telefonního čísla z WhatsAppu",
      "PENDING_ACTION": "Žádost o kontaktní údaje čeká na odpověď",
      "STATES": {
        "PENDING": "Čeká se na kontaktní údaje",
        "SHARED": "Telefonní číslo bylo sdíleno",
        "IDENTITY_CONFLICT": "Telefonní číslo je třeba zkontrolovat"
      }
    },
    "RESPONSE": "Odpověď",
    "RATING_TITLE": "Hodnocení",
    "FEEDBACK_TITLE": "Zpětná vazba",
    "REPLY_MESSAGE_NOT_FOUND": "Zpráva není k dispozici",
    "CARD": {
      "SHOW_LABELS": "Zobrazit štítky",
      "HIDE_LABELS": "Skrýt štítky"
    },
    "HEADER": {
      "MORE": "Další akce",
      "RESOLVE_ACTION": "Vyřešit",
      "REOPEN_ACTION": "Znovu otevřít",
      "OPEN_ACTION": "Otevřít",
      "OPEN": "Více",
      "CLOSE": "Zavřít",
      "DETAILS": "Podrobnosti",
      "SNOOZED_UNTIL": "Odloženo do",
      "SNOOZED_UNTIL_TOMORROW": "Odloženo do zítřka",
      "SNOOZED_UNTIL_NEXT_WEEK": "Odloženo do příštího týdne",
      "SNOOZED_UNTIL_NEXT_REPLY": "Odloženo do další odpovědi",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "zmeškaný",
        "DUE": "termín"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Označit jako čekající",
      "SNOOZE_UNTIL": "Odložit",
      "RESOLVE_WITHOUT_CSAT": "Vyřešit bez CSAT",
      "SNOOZE": {
        "TITLE": "Odložit do",
        "NEXT_REPLY": "Další odpověď",
        "TOMORROW": "Zítra",
        "NEXT_WEEK": "Příští týden"
      }
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Odložit do",
      "APPLY": "Odložit",
      "CANCEL": "Zrušit"
    },
    "PRIORITY": {
      "TITLE": "Priorita",
      "OPTIONS": {
        "NONE": "Žádná",
        "URGENT": "Urgentní",
        "HIGH": "Vysoká",
        "MEDIUM": "Střední",
        "LOW": "Nízká"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Žádná",
        "INPUT_PLACEHOLDER": "Vyberte prioritu",
        "NO_RESULTS": "Žádné výsledky",
        "SUCCESSFUL": "Změněna priorita konverzace ID {conversationId} na {priority}",
        "FAILED": "Nelze změnit prioritu. Zkuste to prosím znovu."
      }
    },
    "SLA": {
      "BREACHED": "porušeno"
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Otevřít v nové záložce",
      "COPY_LINK": "Kopírovat odkaz na konverzaci",
      "COPY_LINK_SUCCESS": "Odkaz na konverzaci zkopírován do schránky",
      "PENDING": "Označit jako čekající",
      "RESOLVED": "Označit jako vyřešené",
      "MARK_AS_UNREAD": "Označit jako nepřečtené",
      "MARK_AS_READ": "Označit jako přečtené",
      "REOPEN": "Znovu otevřít konverzaci",
      "SNOOZE": {
        "TITLE": "Odložit",
        "NEXT_REPLY": "Do další odpovědi",
        "TOMORROW": "Do zítřka",
        "NEXT_WEEK": "Do příštího týdne"
      },
      "ASSIGN_AGENT": "Přiřadit agenta",
      "ASSIGN_LABEL": "Přiřadit štítek",
      "AGENTS_LOADING": "Načítání agentů...",
      "ASSIGN_TEAM": "Přiřadit tým",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Konverzace id {conversationId} přiřazena \"{agentName}\"",
          "FAILED": "Nelze přiřadit agenta. Zkuste to prosím znovu."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Přiřazen štítek #{labelName} ke konverzaci id {conversationId}",
          "FAILED": "Nelze přiřadit štítek. Zkuste to prosím znovu."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Přiřazený tým #{team} ke konverzaci id {conversationId}",
          "FAILED": "Nelze přiřadit tým. Zkuste to prosím znovu."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Podpis zprávy",
      "ENABLE_SIGN_TOOLTIP": "Povolit podpis",
      "DISABLE_SIGN_TOOLTIP": "Zakázat podpis",
      "INSERT_SIGNATURE": "Vložit podpis do editoru",
      "SIGNATURE_PREVIEW_IMAGE": "(obrázkový podpis)",
      "MSG_INPUT": "Shift + enter zadejte pro nový řádek. Začněte '/' pro výběr vzorové odpovědi.",
      "PRIVATE_MSG_INPUT": "Shift + enter zadejte pro nový řádek. Toto bude viditelné pouze pro agenty",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Podpis zprávy není nakonfigurován, prosím nakonfigurujte jej v nastavení profilu.",
      "CLICK_HERE": "Klikněte zde pro aktualizaci",
      "WHATSAPP_TEMPLATES": "WhatsApp šablony",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24hodinové okno WhatsApp vypršelo. Odpovězte pomocí šablony."
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Vaše odpověď je zřejmě v jazyce {draftLanguage}, ale tato konverzace je v jazyce {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Přeložit",
      "REPLY": "Odpověď",
      "PRIVATE_NOTE": "Soukromá poznámka",
      "SEND": "Poslat",
      "SEND_EMAIL": "Odeslat email",
      "SEND_SMS": "Odeslat SMS",
      "NO_SMS_INBOX": "Pro odeslání SMS přidejte SMS schránku.",
      "SEND_CHAT": "Odeslat chat",
      "CREATE": "Přidat poznámku",
      "INSERT_READ_MORE": "Vložit 'Číst více'",
      "DISMISS_REPLY": "Zrušit odpověď",
      "REPLYING_TO": "Odpovídáte na:",
      "REPLY_TO_THIS": "Odpovědět na toto",
      "TIP_EXPAND_ICON": "Zvětšit editor",
      "TIP_COLLAPSE_ICON": "Zmenšit editor",
      "TIP_FORMAT_ICON": "Zobrazit formátovaný textový editor",
      "HEADING_LEVEL": {
        "LABEL": "Styl textu",
        "NORMAL": "Normální text",
        "H1": "Nadpis 1",
        "H2": "Nadpis 2",
        "H3": "Nadpis 3"
      },
      "EDITOR": {
        "BOLD": "Tučně",
        "ITALIC": "Kurzíva",
        "UNDERLINE": "Podtržení",
        "TEXT_COLOR": "Barva textu",
        "BG_COLOR_LABEL": "Barva pozadí",
        "FONT_SIZE_LABEL": "Velikost písma",
        "FONT_SIZE": {
          "XS": "Malé",
          "SM": "Středně malé",
          "MD": "Výchozí",
          "LG": "Velké",
          "XL": "Extra velké",
          "XXL": "Obří"
        },
        "CODE": "Kód",
        "LINK": "Přidat nebo odebrat odkaz",
        "CREATE_LINK": "Vytvořit odkaz",
        "SAVE_LINK": "Uložit",
        "CANCEL": "Zrušit",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Zpět",
        "REDO": "Vpřed",
        "BULLET_LIST": "Odrážkový seznam",
        "ORDERED_LIST": "Číslovaný seznam",
        "BLOCKQUOTE": "Citace",
        "H1": "Nadpis 1",
        "H2": "Nadpis 2",
        "H3": "Nadpis 3",
        "IMAGE_UPLOAD": "Nahrát obrázek",
        "CLEAR_FORMATTING": "Vymazat formátování",
        "COLOR": {
          "RED": "Červená",
          "YELLOW": "Žlutá",
          "BLUE": "Modrá",
          "ROSE_RED": "Růžová",
          "DEEP_CYAN": "Tmavě azurová",
          "ORANGE": "Oranžová",
          "PISTACHIO": "Pistáciová",
          "PURPLE": "Fialová",
          "FUCHSIA": "Fuchsiová",
          "SILVER": "Stříbrná",
          "NAVY": "Námořnická",
          "OLD_PINK": "Starorůžová",
          "AQUA": "Akvamarínová",
          "BROWN": "Hnědá",
          "OLIVE": "Olivová",
          "GOLD": "Zlatá",
          "BEIGE": "Béžová",
          "WINE": "Vínová",
          "FOREST": "Lesní",
          "GREEN": "Zelená",
          "BLUE_GREY": "Modrošedá",
          "RUBY_RED": "Rubínová",
          "CHESTNUT_BROWN": "Kaštanová",
          "ASH_GREY": "Popelavě šedá"
        },
        "BG_COLOR": {
          "RED": "Červená",
          "YELLOW": "Žlutá",
          "BLUE": "Modrá",
          "ROSE_RED": "Růžová",
          "DEEP_CYAN": "Tmavě azurová",
          "ORANGE": "Oranžová",
          "PISTACHIO": "Pistáciová",
          "PURPLE": "Fialová",
          "FUCHSIA": "Fuchsiová",
          "SILVER": "Stříbrná",
          "NAVY": "Námořnická",
          "OLD_PINK": "Starorůžová",
          "AQUA": "Akvamarínová",
          "BROWN": "Hnědá",
          "OLIVE": "Olivová",
          "GOLD": "Zlatá",
          "BEIGE": "Béžová",
          "WINE": "Vínová",
          "FOREST": "Lesní",
          "GREEN": "Zelená",
          "BLUE_GREY": "Modrošedá",
          "RUBY_RED": "Rubínová",
          "CHESTNUT_BROWN": "Kaštanová",
          "ASH_GREY": "Popelavě šedá"
        }
      },
      "TIP_EMOJI_ICON": "Zobrazit výběr emoji",
      "TIP_ATTACH_ICON": "Přiložit soubory",
      "TIP_AUDIORECORDER_ICON": "Nahrát zvuk",
      "TIP_AUDIORECORDER_PERMISSION": "Povolit přístup ke zvuku",
      "TIP_AUDIORECORDER_ERROR": "Zvuk se nepodařilo otevřít",
      "DRAG_DROP": "Přetažením sem připojíte",
      "START_AUDIO_RECORDING": "Spustit nahrávání zvuku",
      "STOP_AUDIO_RECORDING": "Zastavit nahrávání zvuku",
      "EMAIL_HEAD": {
        "EDIT": "Upravit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Skrýt",
        "INCLUDE_ORIGINAL_MESSAGE": "Zahrnout pod odpověď původní zprávu",
        "TO": "KOMU",
        "ADD_BCC": "Skrytá kopie",
        "EDIT_HEADERS": "Upravit",
        "HIDE_HEADER_EDITS": "Skrýt úpravy",
        "CC": {
          "LABEL": "KOPIE",
          "PLACEHOLDER": "Vyhledat kontakt podle e-mailové adresy",
          "ERROR": "Zadejte prosím platnou e-mailovou adresu"
        },
        "BCC": {
          "LABEL": "SKRYTÁ KOPIE",
          "PLACEHOLDER": "Vyhledat kontakt podle e-mailové adresy",
          "ERROR": "Zadejte prosím platnou e-mailovou adresu"
        },
        "SUBJECT": {
          "LABEL": "PŘEDMĚT",
          "PLACEHOLDER": "Předmět emailu",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Nedefinované proměnné",
        "MESSAGE": "Ve vaší zprávě máte {undefinedVariablesCount} nedefinovaných proměnných: {undefinedVariables}. Chcete přesto zprávu odeslat?",
        "CONFIRM": {
          "YES": "Poslat",
          "CANCEL": "Zrušit"
        }
      },
      "COPILOT": {
        "Q": "Nápověda od robota"
      }
    },
    "VISIBLE_TO_AGENTS": "Soukromá poznámka: Viditelné pouze pro vás a váš tým",
    "CHANGE_STATUS": "Stav konverzace byl změněn",
    "CHANGE_STATUS_FAILED": "Změna stavu konverzace se nezdařila",
    "CHANGE_AGENT": "Konverzace pověřená osoba změněna",
    "CHANGE_AGENT_FAILED": "Změna přiřazeného agenta se nezdařila",
    "ASSIGN_LABEL_SUCCESFUL": "Štítek byl úspěšně přiřazen",
    "ASSIGN_LABEL_FAILED": "Přiřazení štítku se nezdařilo",
    "CHANGE_TEAM": "Tým konverzace se změnil",
    "IMAGE_UPLOAD_ERROR": "Nepodařilo se nahrát obrázek, zkuste to prosím znovu",
    "FILE_SIZE_LIMIT": "Soubor překračuje limit příloh {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "DRAFT": {
      "FILE_TOO_LARGE": "Soubor '{fileName}' ({fileSize}) je příliš velký pro uložení v konceptu a bude přeskočen",
      "ATTACHMENT_SERIALIZATION_FAILED": "Nepodařilo se serializovat přílohu pro uložení konceptu",
      "STORAGE_QUOTA_EXCEEDED": "Překročena kvóta úložiště. Koncept byl uložen bez příloh",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Nepodařilo se uložit koncept ani bez příloh",
      "SAVE_FAILED": "Nepodařilo se uložit koncept konverzace"
    },
    "MESSAGE_ERROR": "Nepodařilo se odeslat tuto zprávu, zkuste to prosím později",
    "SENT_BY": "Odeslal:",
    "BOT": "Bot",
    "SEND_FAILED": "Odeslání zprávy se nezdařilo! Zkuste to znovu",
    "TRY_AGAIN": "opakovat",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Vybrat agenta",
      "REMOVE": "Odebrat",
      "ASSIGN": "Přiřadit"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopírovat",
      "REPLY_TO": "Odpovědět na tuto zprávu",
      "DELETE": "Vymazat",
      "CREATE_A_CANNED_RESPONSE": "Vytvořit šablonu",
      "TRANSLATE": "Přeložit",
      "COPY_PERMALINK": "Kopírovat odkaz na zprávu",
      "LINK_COPIED": "URL zprávy zkopírována do schránky",
      "FORWARD": "Přeposlat",
      "FORWARD_ERROR": "Nepodařilo se připravit přeposílanou zprávu",
      "DELETE_CONFIRMATION": {
        "TITLE": "Opravdu chcete tuto zprávu smazat?",
        "MESSAGE": "Tuto akci nelze vrátit zpět",
        "DELETE": "Vymazat",
        "CANCEL": "Zrušit"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Kontakt",
      "COPILOT": "Kopilot"
    },
    "COMMENT_TREE": {
      "TITLE": "Vlákno komentářů",
      "EMPTY": "Žádné komentáře k zobrazení",
      "VIEW_TREE": "Zobrazit vlákno komentářů"
    },
    "MESSAGE_EVENT": {
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Volané klapky:",
          "CALL_COMPLETED": "Hovor dokončen",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "zvednuto jinde, zvonilo {duration}",
            "NO_ANSWER": "nezvednuto, zvonilo {duration}",
            "REJECTED": "odmítnuto, zvonilo {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operátor",
            "QUEUE": "Fronta",
            "RING_GROUP": "Skupina"
          },
          "INBOUND_CALL": "Příchozí hovor od {number} na {did}",
          "IVR_HANDLED": "Zpracováno IVR automatem",
          "IVR_LABEL_NOT_FOUND": "Chtěl jsem přiřadit štítek {name}, ale už neexistuje, prosím zkontrolujte nastavení.",
          "CALL_MISSED": "Zmeškaný hovor",
          "CALL_NO_ANSWER": "Nedovolali jsme se",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Automaticky vyřešeno po {count} neúspěšných pokusech o kontakt",
          "OUTBOUND_CALL": "Odchozí hovor od {agentName} z {did} na {number}",
          "SUMMARY_NOT_AVAILABLE": "Nepodařilo se vygenerovat shrnutí.",
          "RECORDING_DELETED": "Nahrávka hovoru byla smazána uživatelem {name}, {date}"
        }
      },
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Konverzace byla vyřešena uživatelem {userName}",
          "RESOLVED_WITHOUT_CSAT": "Konverzace byla vyřešena uživatelem {userName} (bez CSAT)",
          "CONTACT_RESOLVED": "Konverzace byla uzavřena {contactName}",
          "OPEN": "Konverzace byla otevřena uživatelem {userName}",
          "PENDING": "Konverzace byla označena jako čekající uživatelem {userName}",
          "SNOOZED": "Konverzace byla ztlumena uživatelem {userName}",
          "AUTO_RESOLVED_INACTIVE": "Konverzace byla označena jako vyřešená systémem kvůli {duration} hodinám nečinnosti",
          "AUTO_RESOLVED": "Konverzace byla označena jako vyřešená systémem.",
          "AUTO_RESOLVED_EMPTY": "Konverzace byla systémem označena jako vyřešená, protože byla prázdná.",
          "SYSTEM_AUTO_OPEN": "Systém znovu otevřel konverzaci kvůli nové příchozí zprávě.",
          "AUTO_REOPENED": "Systém znovu otevřel konverzaci po uplynutí ztlumení.",
          "BLOCKED_CONTACT_RESOLVED": "Systém vyřešil konverzaci, protože kontakt je blokovaný.",
          "KAUFLAND_TICKET_CLOSED": "Systém vyřešil konverzaci, protože ticket byl uzavřen na Kauflandu."
        },
        "PRIORITY": {
          "ADDED": "{userName} nastavil prioritu na {newPriority}",
          "UPDATED": "{userName} změnil prioritu z {oldPriority} na {newPriority}",
          "REMOVED": "{userName} odstranil prioritu"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} si tuto konverzaci přiřadil/a",
          "ASSIGNED": "Přiřazeno k {assigneeName} uživatelem {userName}",
          "REMOVED": "Přiřazení zrušeno uživatelem {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Přiřazeno týmu {teamName} uživatelem {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Přiřazeno {assigneeName} přes tým {teamName} uživatelem {userName}",
          "REMOVED": "Odebráno z týmu {teamName} uživatelem {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} přidal/a štítek {labels}",
          "REMOVED": "{userName} odebral/a štítek {labels}"
        },
        "SLA": {
          "ADDED": "{userName} přidal/a SLA politiku {slaName}",
          "REMOVED": "{userName} odebral/a SLA politiku {slaName}",
          "UPDATED": "{userName} upravil/a SLA politiku {slaName}"
        },
        "MUTED": "{userName} ztlumil/a konverzaci",
        "UNMUTED": "{userName} zrušil/a ztlumení konverzace",
        "CONTACT_BLOCKED": "{userName} zablokoval/a kontakt",
        "CONTACT_UNBLOCKED": "{userName} odblokoval/a kontakt",
        "DOMAIN_BLOCKED": "{userName} zablokoval/a všechny kontakty pro danou doménu",
        "DOMAIN_UNBLOCKED": "{userName} odblokoval/a všechny kontakty pro danou doménu",
        "MOVED": "{userName} přesunul/a tuto konverzaci ze schránky {sourceInboxName} do schránky {targetInboxName}",
        "MOVED_BY_ORDER": "Přesunuto, protože objednávky kontaktu jsou jen z e-shopu {storeName} (poslední objednávka {orderId}), jehož robot odpovídá v této schránce.",
        "MERGED": "{userName} sloučil/a konverzaci #{sourceId} do této konverzace",
        "AUTOMATION_RULE_TRIGGERED": "Automatizační pravidlo \"{ruleName}\" spuštěno",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automatizační pravidlo \"{ruleName}\" zakázalo automatickou prioritu",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automatizační pravidlo \"{ruleName}\" zakázalo automatické štítkování",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automatizační pravidlo \"{ruleName}\" zastavilo další zpracování pravidel",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Odeslání zprávy bylo přeskočeno pro tuto automatickou odpověď",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatizace byla přeskočena, protože kontakt je blokován",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatizace \"{ruleName}\" nemohla přesunout tuto konverzaci ze schránky {sourceInboxName} do schránky {targetInboxName}, protože schránky nejsou kompatibilní.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatizace \"{ruleName}\" nemohla přesunout tuto konverzaci ze schránky {sourceInboxName} do schránky {targetInboxName}, protože kontakt nemá e-mailovou adresu.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatizace \"{ruleName}\" nemohla odeslat zprávu: tato telefonní schránka nemůže posílat SMS, protože účet nemá žádnou SMS schránku. Pravidlo bylo vypnuto a administrátoři dostali e-mail.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatizace \"{ruleName}\" nemohla odeslat zprávu: přílohy z této schránky nelze odeslat přes SMS. Pravidlo bylo vypnuto a administrátoři dostali e-mail.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Makro \"{macroName}\" neodeslalo zprávu: tato telefonní schránka nemůže posílat SMS, protože účet nemá žádnou SMS schránku.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Makro \"{macroName}\" neodeslalo zprávu: přílohy z této schránky nelze odeslat přes SMS.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Makro \"{macroName}\" neodeslalo zprávu: konverzaci řeší bot. Nejprve konverzaci otevřete.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Makro \"{macroName}\" neodeslalo zprávu: tato schránka je označena ke smazání. Nejprve přesuňte konverzaci do jiné schránky.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatizace \"{ruleName}\" odeslala e-mail na {contactEmail} v nové konverzaci [#{conversationId}]({conversationPath}) ve schránce {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatizace \"{ruleName}\" založila tuto konverzaci na základě konverzace [#{conversationId}]({conversationPath}) ve schránce {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatizace \"{ruleName}\" nemohla odeslat zprávu v nové konverzaci ve schránce {inboxName}, protože kontakt nemá e-mailovou adresu.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatizace \"{ruleName}\" odeslala SMS na {contactPhone} v nové konverzaci [#{conversationId}]({conversationPath}) ve schránce {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatizace \"{ruleName}\" nemohla odeslat SMS v nové konverzaci ve schránce {inboxName}, protože kontakt nemá telefonní číslo.",
        "AUTO_LABELING": {
          "REASONING": "Použité štítky: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Aktualizovaná priorita: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Zákazník"
          }
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Poslat přepis konverzace",
    "DESC": "Poslat kopii přepisu konverzace na zadanou e-mailovou adresu",
    "SUBMIT": "Odeslat",
    "CANCEL": "Zrušit",
    "SEND_EMAIL_SUCCESS": "Přepis chatu byl úspěšně odeslán",
    "SEND_EMAIL_ERROR": "Došlo k chybě, zkuste to prosím znovu",
    "FORM": {
      "SEND_TO_CONTACT": "Poslat přepis zákazníkovi",
      "SEND_TO_AGENT": "Zašlete přepis přidělenému agentovi",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Poslat přepis na jinou e-mailovou adresu",
      "EMAIL": {
        "PLACEHOLDER": "Zadejte e-mailovou adresu",
        "ERROR": "Zadejte prosím platnou e-mailovou adresu"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Ahoj, 👋, Vítejte na {installationName}!",
    "DESCRIPTION": "Děkujeme za registraci. Chceme, abyste získali maximum z {installationName}. Zde je několik věcí, které můžete v {installationName} udělat, abyste udělali zážitek příjemný.",
    "GREETING_MORNING": "👋 Dobré ráno, {name}. Vítejte v {installationName}.",
    "GREETING_AFTERNOON": "👋 Dobré odpoledne, {name}. Vítejte v {installationName}.",
    "GREETING_EVENING": "👋 Dobrý večer, {name}. Vítejte v {installationName}.",
    "READ_LATEST_UPDATES": "Přečtěte si nejnovější aktualizace",
    "ALL_CONVERSATION": {
      "TITLE": "Všechny vaše konverzace na jednom místě",
      "DESCRIPTION": "Zobrazit všechny konverzace od zákazníků na jednom nástěnce. Můžete filtrovat konverzace podle příchozího kanálu, popisku a stavu.",
      "NEW_LINK": "Klikněte zde pro vytvoření schránky"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Pozvěte své členy týmu",
      "DESCRIPTION": "Vzhledem k tomu, že se připravujete na rozhovor se zákazníkem, přiveďte své týmové spolupracovníky, kteří Vám pomohou. Můžete pozvat své spolupracovníky přidáním jejich e-mailové adresy do seznamu agentů.",
      "NEW_LINK": "Klikněte zde pro pozvání člena týmu"
    },
    "LABELS": {
      "TITLE": "Spravovat konverzace s popisky",
      "DESCRIPTION": "Štítky poskytují jednodušší způsob, jak kategorizovat vaši konverzaci. Vytvořte nějaké štítky jako #podpora, #fakturace atd., abyste je mohli použít v konverzaci později.",
      "NEW_LINK": "Klikněte zde pro vytvoření štítků"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Vytvořit předpřipravené odpovědi",
      "DESCRIPTION": "Předem napsané šablony rychlých odpovědí vám pomohou rychle reagovat na konverzace. Agenti mohou napsat znak '/' následovaný zkratkou pro vložení odpovědi.",
      "NEW_LINK": "Klikněte zde pro vytvoření předpřipravené odpovědi"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Přiřazený agent",
    "SELF_ASSIGN": "Přiřadit mi",
    "TEAM_LABEL": "Přiřazený tým",
    "SELECT": {
      "PLACEHOLDER": "Nic"
    },
    "ACCORDION": {
      "ORDER_HISTORY": "Historie objednávek",
      "CONTACT_DETAILS": "Podrobnosti kontaktu",
      "CONVERSATION_ACTIONS": "Akce konverzace",
      "CONVERSATION_LABELS": "Štítky konverzace",
      "CONVERSATION_INFO": "Informace o konverzaci",
      "CONTACT_ATTRIBUTES": "Atributy kontaktu",
      "PREVIOUS_CONVERSATION": "Předchozí konverzace",
      "MACROS": "Makra",
      "RETINO_TICKETS": "Retino Tikety",
      "CUSTOM_DATA_PROVIDER": "Vlastní data",
      "SHOPIFY_ORDERS": "Shopify Objednávky"
    },
    "SHOPIFY": {
      "ORDER_ID": "Objednávka #{id}",
      "ERROR": "Chyba při načítání objednávek",
      "NO_SHOPIFY_ORDERS": "Nebyly nalezeny žádné objednávky",
      "FINANCIAL_STATUS": {
        "PENDING": "Čekající",
        "AUTHORIZED": "Autorizováno",
        "PARTIALLY_PAID": "Částečně zaplaceno",
        "PAID": "Zaplaceno",
        "PARTIALLY_REFUNDED": "Částečně vráceno",
        "REFUNDED": "Vráceno",
        "VOIDED": "Zrušeno"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Vyřízeno",
        "PARTIALLY_FULFILLED": "Částečně vyřízeno",
        "UNFULFILLED": "Nevyřízeno"
      }
    }
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Načíst více",
    "NO_RECORDS_FOUND": "Nebyly nalezeny žádné tickety",
    "LOAD_ERROR": "Nepodařilo se načíst tickety z {hookName}. Zkuste to prosím později.",
    "NOT_SEARCHABLE": "Kontaktní email není znám.",
    "TIMES": "&times;"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "Nebyla nalezena žádná data",
    "LOAD_ERROR": "Nepodařilo se načíst data. Zkuste to prosím později."
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Načítám...",
    "NO_ORDERS": "Zatím žádné objednávky",
    "NOT_AVAILABLE": "Informace o zákazníkovi nejsou k dispozici",
    "EXPAND": "Otevřít kartu zákazníka",
    "MORE_ITEMS": "+ {count} položky",
    "EXPEDITION_STATUS": "Stav expedice",
    "OPEN_DETAIL": "otevřít detail",
    "COPY_ORDER_ID": "Číslo objednávky",
    "EXTERNAL_ID": "Variabilní symbol",
    "PAYMENT_TYPE": "Způsob platby",
    "PAYMENT_DATE": "Datum platby",
    "DELIVERY_PROVIDER": "Dopravce",
    "EXPECTED_DATE_OF_DELIVERY": "Očekávané doručení",
    "DATE_OF_DELIVERY": "Doručeno",
    "EXPEDITION_DATE": "Datum expedice",
    "INTERNAL_NOTE": "Poznámka e-shopu",
    "PACKAGE_NUMBER": "Zásilka"
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Vytvořit atribut",
    "NO_RECORDS_FOUND": "Nebyly nalezeny žádné atributy",
    "UPDATE": {
      "SUCCESS": "Atribut byl úspěšně aktualizován",
      "ERROR": "Atribut nelze aktualizovat. Zkuste to prosím později"
    },
    "ADD": {
      "TITLE": "Přidat",
      "SUCCESS": "Atribut byl úspěšně přidán",
      "ERROR": "Nelze přidat atribut. Zkuste to prosím později"
    },
    "DELETE": {
      "SUCCESS": "Atribut byl úspěšně odstraněn",
      "ERROR": "Atribut nelze odstranit. Zkuste to prosím později"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Přidat atributy",
      "PLACEHOLDER": "Hledat atributy",
      "NO_RESULT": "Nebyly nalezeny žádné atributy"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Od",
    "TO": "Komu",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Předmět"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Účastníci",
    "SIDEBAR_TITLE": "Účastníci konverzace",
    "NO_RECORDS_FOUND": "Žádné výsledky",
    "ADD_PARTICIPANTS": "Vyberte účastníky",
    "SEARCH_PLACEHOLDER": "Hledat",
    "REMANING_PARTICIPANTS_TEXT": "+{count} dalších",
    "REMANING_PARTICIPANT_TEXT": "+{count} další",
    "TOTAL_PARTICIPANTS_TEXT": "{count} lidí se účastní.",
    "TOTAL_PARTICIPANT_TEXT": "{count} osoba se účastní.",
    "NO_PARTICIPANTS_TEXT": "Nikdo se neúčastní!",
    "WATCH_CONVERSATION": "Připojit se ke konverzaci",
    "YOU_ARE_WATCHING": "Účastníte se",
    "API": {
      "ERROR_MESSAGE": "Nelze aktualizovat, zkuste to znovu!",
      "SUCCESS_MESSAGE": "Účastníci aktualizováni!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Zobrazit přeložený obsah",
    "DESC": "Můžete si zobrazit přeložený obsah v jednotlivých jazycích.",
    "ORIGINAL_CONTENT": "Původní obsah",
    "TRANSLATED_CONTENT": "Přeložený obsah",
    "NO_TRANSLATIONS_AVAILABLE": "Pro tento obsah nejsou dostupné žádné překlady"
  },
  "TYPING": {
    "ONE": "{user} právě píše",
    "TWO": "{user} a {secondUser} právě píší",
    "MULTIPLE": "{user} a {count} další právě píší",
    "IMAGE_ALT": "Někdo právě píše"
  },
  "READING": {
    "ONE": "{user} čte tento tiket",
    "TWO": "{user} a {secondUser} čtou tento tiket",
    "MULTIPLE": "{user} a {count} další čtou tento tiket"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Zkus tyto zadání"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Přesunout konverzaci",
    "DESCRIPTION": "Přesuňte tuto konverzaci do jiné emailové schránky.",
    "SOURCE": {
      "TITLE": "Konverzace",
      "ID_LABEL": "ID konverzace"
    },
    "TARGET": {
      "TITLE": "Cílová schránka",
      "PLACEHOLDER": "Vyberte emailovou schránku",
      "NO_RESULTS": "Žádné jiné emailové schránky nejsou k dispozici",
      "ERROR": "Prosím vyberte cílovou schránku"
    },
    "SUBMIT": "Přesunout konverzaci",
    "CANCEL": "Zrušit",
    "SUCCESS_MESSAGE": "Konverzace byla úspěšně přesunuta",
    "ERROR_MESSAGE": "Nepodařilo se přesunout konverzaci. Zkuste to prosím znovu."
  },
  "MERGE": {
    "TITLE": "Sloučit konverzace",
    "DESCRIPTION": "Sloučit tuto konverzaci s jinou konverzací. Všechny zprávy z této konverzace budou přesunuty do cílové konverzace a tato konverzace bude smazána.",
    "SOURCE": {
      "TITLE": "Zdrojová konverzace (bude smazána)",
      "ID_LABEL": "ID konverzace"
    },
    "TARGET": {
      "TITLE": "Cílová konverzace",
      "PLACEHOLDER": "Zadejte ID pro vyhledání (např. 123)",
      "HELP": "Zadejte ID konverzace, do které chcete sloučit všechny zprávy.",
      "ERROR": "Prosím vyberte cílovou konverzaci"
    },
    "WARNING": "Varování: Tuto akci nelze vrátit zpět. Všechny zprávy budou přesunuty do cílové konverzace a tato konverzace bude trvale smazána.",
    "SUBMIT": "Sloučit konverzace",
    "CANCEL": "Zrušit",
    "SUCCESS_MESSAGE": "Konverzace byla úspěšně sloučena",
    "ERROR_MESSAGE": "Konverzace se nepodařilo sloučit. Zkontrolujte prosím cílovou konverzaci a zkuste to znovu.",
    "SEARCH": {
      "NO_RESULTS": "Konverzace s tímto ID nebyla nalezena",
      "ERROR_MESSAGE": "Nepodařilo se vyhledat konverzace. Zkuste to prosím znovu."
    },
    "CONFIRM": {
      "TITLE": "Potvrdit sloučení",
      "DESCRIPTION": "Opravdu chcete sloučit tuto konverzaci? Tuto akci nelze vrátit zpět.",
      "YES": "Ano, sloučit",
      "CANCEL": "Zrušit"
    }
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Nepodařilo se stáhnout přílohy, zkuste to za chvíli znovu"
  }
}
